const vehiclePages = (permissions) => ({
	pages: {
		id: 'pages',
		text: 'Vehicles',
		icon: 'Extension',
	},
	singlePages: {
		id: 'vehiclePages',
		text: 'Vehicle Settigs',
		path: 'vehicle-settings',
		icon: 'SettingsApplications',
		subMenu: {
			vehicleMake: {
				id: 'vehicleMake',
				text: 'Makes',
				path: 'vehicle-settings/makes?page=1&limit=20',
				icon: 'CarRepair',
				hide: !permissions?.['make.index'],
			},
			vehicleModel: {
				id: 'vehicleModel',
				text: 'Models',
				path: 'vehicle-settings/models?page=1&limit=20',
				icon: 'ElectricCar',
				hide: !permissions?.['model.index'],
			},
			vehicleBodyStyle: {
				id: 'vehicleBodyStyle',
				text: 'BodyStyle',
				path: 'vehicle-settings/body-style',
				icon: 'CarRepair',
				hide: !permissions?.['body-styles.index'],
			},
		},
	},
});

const vehicles = (permissios) => ({
	singlePages: {
		id: 'vehiclePage',
		text: 'Vehicles',
		path: 'vehicles?page=1&limit=20',
		icon: 'ElectricCar',
		subMenu: null,
		hide: !permissios?.['vehicle.index'],
	},
});

const allVehicle = (permissions) => ({
	pages: {
		id: 'pages',
		text: 'Vehicles',
		icon: 'ElectricCar',
		hide: !permissions?.['vehicle.index'],
	},
	singlePages: {
		id: 'vehiclePage',
		text: 'Vehicles',
		path: 'vehicles',
		icon: 'ElectricCar',
		hide: !permissions?.['vehicle.index'],

		subMenu: {
			inventory: {
				id: 'inventory',
				text: 'In Stock',
				path: 'inventory-vehicles?page=1&limit=20&statuses=1',
				icon: 'ElectricCar',
				hide: !permissions?.['on-hand.index'],
			},

			on_approval: {
				id: 'on_approval',
				text: 'On Approval',
				path: 'on-approval-vehicles?page=1&limit=20&statuses=0,25',
				icon: 'ElectricCar',
				hide: !permissions?.['on-approval.index'],
			},

			documents_validation_pending: {
				id: 'documents_validation_pending',
				text: 'Doc Validation Pending',
				path: 'documents-validation-pending-vehicles?page=1&limit=20&statuses=26',
				icon: 'ElectricCar',
				hide: !permissions?.['doc-validation-pending.index'],
			},

			auction_vehicle: {
				id: 'auction_vehicle',
				text: 'Auction Vehicle',
				path: 'auction-vehicles?page=1&limit=20&statuses=5,10',
				icon: 'ElectricCar',
				hide: !permissions?.['auction-vehicle.index'],
			},

			sold_vehicle: {
				id: 'sold_vehicle',
				text: 'Sold Vehicle',
				path: 'sold-vehicles?page=1&limit=20&statuses=15,20&with_invoice_cancel=1',
				icon: 'ElectricCar',
				hide: !permissions?.['sold-vehicle.index'],
			},

			unsold: {
				id: 'unsold_vehicle',
				text: 'UnSold Vehicle',
				path: 'relist-vehicles?page=1&limit=20&statuses=17',
				icon: 'ElectricCar',
				hide: !permissions?.['unsold-vehicle.index'],
			},

			selling_on_approval: {
				id: 'selling_on_approval_vehicle',
				text: 'Selling On Approval',
				path: 'selling-on-approval-vehicles?page=1&limit=20',
				icon: 'ElectricCar',
				hide: !permissions?.['selling-on-approval.index'],
			},

			// returned_vehicle: {
			// 	id: 'returned_vehicle',
			// 	text: 'Return Vehicle',
			// 	path: 'returned-vehicles?page=1&limit=20',
			// 	icon: 'ElectricCar',
			// 	hide: !permissions?.['return-vehicle.index'],
			// },

			all_vehicle: {
				id: 'all_vehicle',
				text: 'Inventory',
				path: 'vehicles?inventory=true&page=1&limit=20',
				icon: 'ElectricCar',
				hide: !permissions?.['inventory.index'],
			},
			con_vehicle: {
				id: 'consigner_vehicle',
				text: 'Consign. Cars',
				path: 'consigner-cars?page=1&limit=20&with_out_gca=1',
				icon: 'ElectricCar',
				hide: !permissions?.['consigner-vehicles.index'],
			},
			advised_return: {
				id: 'advised_return',
				text: 'For Return Veh.',
				path: 'advised-return-vehicles?page=1&limit=20',
				icon: 'ElectricCar',
				hide: !permissions?.['advised_to_return.index'],
			},
		},
	},
});

const misc = (permissions) => ({
	pages: {
		id: 'pages',
		text: 'Misc.',
		icon: 'MiscellaneousServices',
		// hide: !permissions?.['misc.index'],
	},
	singlePages: {
		id: 'misc',
		text: 'Misc.',
		path: 'misc',
		icon: 'MiscellaneousServices',
		// hide: !permissions?.['misc.index'],

		subMenu: {
			banners: {
				id: 'banners',
				text: 'Banners',
				path: 'settings/banners?page=1&limit=20',
				icon: 'Image',
				hide: !permissions?.['banners.index'],
			},
			catalogues: {
				id: 'catalogs',
				text: 'Catalogs',
				path: 'settings/catalogs?page=1&limit=20',
				icon: 'DriveFileMove',
				hide: !permissions?.['catalogues.index'],
			},

			customer_queries: {
				id: 'customer_queries_page',
				text: 'Customer Queries',
				path: 'customer-queries?page=1&limit=20',
				icon: 'Quickreply',
				subMenu: null,
				hide: !permissions?.['faq.customer_queries'],
			},

			faqs: {
				id: 'faq-page',
				text: 'FAQ',
				path: 'faqs?page=1&limit=20',
				icon: 'Quickreply',
				subMenu: null,
				hide: !permissions?.['faq.index'],
			},

			jobs: {
				id: 'jobs',
				text: 'Jobs',
				path: 'jobs?page=1&limit=20',
				icon: 'AddTask',
				subMenu: null,
				hide: !permissions?.['jobs.index'],
			},

			downloadFile: {
				id: 'downloadFile',
				text: 'Download Files',
				path: 'settings/download-files?page=1&limit=20',
				icon: 'DriveFileMove',
				hide: !permissions?.['downloads.index'],
			},

			content: {
				id: 'content',
				text: 'Content',
				path: 'contents',
				icon: 'ContentPaste',
				hide: !permissions?.['content.index'],
			},
			blog: {
				id: 'blog',
				text: 'Blogs',
				path: 'blogs?page=1&limit=20',
				icon: 'ImportContacts',
				hide: !permissions?.['blog.index'],
			},
		},
	},
});

const bannerSlider = (permissions) => ({
	pages: {
		id: 'Banners',
		text: 'Banners.',
		icon: 'Image',
		hide: !permissions?.['vehicle.index'],
	},
	singlePages: {
		id: 'banners',
		text: 'Banners.',
		path: 'banners',
		icon: 'Image',
		// hide: !permissions?.['vehicle.index'],

		subMenu: {
			banners: {
				id: 'banners',
				text: 'Home Slider',
				path: 'settings/banners?page=1&limit=20',
				icon: 'Image',
				hide: !permissions?.['banners.index'],
			},
			aboutbanners: {
				id: 'about-banners',
				text: 'About Banners',
				path: 'settings/about-banners?page=1&limit=20',
				icon: 'Image',
				hide: !permissions?.['banners.index'],
			},
			contactbanners: {
				id: 'contact-banners',
				text: 'Contact Banners',
				path: 'settings/contact-banners?page=1&limit=20',
				icon: 'Image',
				hide: !permissions?.['banners.index'],
			},
			downloadbanners: {
				id: 'download-banners',
				text: 'Download Banners',
				path: 'settings/download-banners?page=1&limit=20',
				icon: 'Image',
				hide: !permissions?.['banners.index'],
			},
			careerbanners: {
				id: 'career-banners',
				text: 'Career Banners',
				path: 'settings/career-banners?page=1&limit=20',
				icon: 'Image',
				hide: !permissions?.['banners.index'],
			},
			blogbanners: {
				id: 'blog-banners',
				text: 'Blog Banners',
				path: 'settings/blog-banners?page=1&limit=20',
				icon: 'Image',
				hide: !permissions?.['banners.index'],
			},
			popupbanners: {
				id: 'popup-banners',
				text: 'Popup Banners',
				path: 'settings/popup-banners?page=1&limit=20',
				icon: 'Image',
				hide: !permissions?.['banners.index'],
			},
		},
	},
});

const accountingPage = (permissions) => ({
	pages: {
		id: 'accounting-page',
		text: 'Accounting',
		icon: 'Calculate',
	},
	singlePages: {
		id: 'invoiePage',
		text: 'Invoice',
		icon: 'Calculate',
		hide: !permissions?.['accounting.index'],
		subMenu: {
			invoice: {
				id: 'invoicePage',
				text: 'Invoice',
				path: 'invoices?page=1&limit=20',
				icon: 'Calculate',
				subMenu: null,
			},
			service: {
				id: 'servicePage',
				text: 'Product & Service',
				path: 'product-service?page=1&limit=20',
				icon: 'People',
				subMenu: null,
			},
		},
	},
});

const settings = (permissions) => ({
	pages: {
		id: 'pages',
		text: 'Settings',
		icon: 'Extension',
	},
	singlePages: {
		id: 'settingsPage',
		text: 'Settings',
		path: 'settings',
		icon: 'SettingsApplications',
		subMenu: {
			systemSettings: {
				id: 'system_settings',
				text: 'System Settings',
				path: 'settings/system-settings',
				icon: 'AppSettingsAlt',
				hide: !permissions?.['user.index'],
			},

			user: {
				id: 'users',
				text: 'Users',
				path: 'settings/users?page=1&limit=20',
				icon: 'AccountCircle',
				hide: !permissions?.['user.index'],
			},

			role: {
				id: 'roles',
				text: 'Roles',
				path: 'settings/roles',
				icon: 'Lock',
				hide: !permissions?.['role.index'],
			},
			// zones: {
			// 	id: 'zones',
			// 	text: 'Zones',
			// 	path: 'settings/zones?page=1&limit=20',
			// 	icon: 'AcUnit',
			// 	hide: !permissions?.['zone.index'],
			// },
			countries: {
				id: 'countries',
				text: 'Countries',
				path: 'settings/countries?page=1&limit=20',
				icon: 'LocationCity',
				hide: !permissions?.['country.index'],
			},
			states: {
				id: 'states',
				text: 'States',
				path: 'settings/states?page=1&limit=20',
				icon: 'AccountBalance',
				hide: !permissions?.['state.index'],
			},
			locations: {
				id: 'locations',
				text: 'Locations',
				path: 'settings/locations?page=1&limit=20',
				icon: 'Map',
				hide: !permissions?.['location.index'],
			},
			acutionYard: {
				id: 'acutionYard',
				text: 'Auction Yard',
				path: 'settings/auction-yard?page=1&limit=20',
				icon: 'CarRental',
				hide: !permissions?.['yard.index'],
			},
			vehicleMake: {
				id: 'vehicleMake',
				text: 'Makes',
				path: 'vehicle-settings/makes?page=1&limit=20',
				icon: 'CarRepair',
				hide: !permissions?.['make.index'],
			},
			vehicleBodyStyle: {
				id: 'vehicleBodyStyle',
				text: 'Body Style',
				path: 'vehicle-settings/body-style?page=1&limit=20',
				icon: 'CarRepair',
				hide: !permissions?.['body-styles.index'],
			},
			vehicleColorStyle: {
				id: 'vehicleColorStyle',
				text: 'Color Style',
				path: 'vehicle-settings/color-style?page=1&limit=20',
				icon: 'CarRepair',
				hide: !permissions?.['vehicle-colors.index'],
			},
			vehicleDamage: {
				id: 'vehicleDamage',
				text: 'Vehicle Damage',
				path: 'vehicle-settings/vehicle-damage?page=1&limit=20',
				icon: 'CarRepair',
				hide: !permissions?.['vehicle-damages.index'],
			},
			vehicleModel: {
				id: 'vehicleModel',
				text: 'Models',
				path: 'vehicle-settings/models?page=1&limit=20',
				icon: 'ElectricCar',
				hide: !permissions?.['model.index'],
			},

			email_template: {
				id: 'email-notifications',
				text: 'Email Notifications',
				path: 'settings/email-notifications?page=1&limit=20',
				icon: 'Email',
				hide: !permissions?.['email-notification.index'],
			},
			pages: {
				id: 'pages',
				text: 'Pages',
				path: 'settings/pages?page=1&limit=20',
				icon: 'Pages',
				hide: !permissions?.['page.index'],
			},
		},
	},
});

const accountPage = (permissions) => ({
	pages: {
		id: 'pages',
		text: 'Accounting',
		icon: 'Calculate',
	},
	singlePages: {
		id: 'accountPAge',
		text: 'Accounting',
		path: 'accounting',
		icon: 'Calculate',
		subMenu: {
			soldVehicle: {
				id: 'soldVehiclePage',
				text: 'Sold Vehicle',
				path: 'sold-accounting-vehicle?page=1&limit=20&&status=15',
				icon: 'Money',
				subMenu: null,
				hide: true, // !permissions?.['accounting.sold_vehicle'],
			},
			service: {
				id: 'servicePage',
				text: 'Product & Service',
				path: 'product-service?page=1&limit=20',
				icon: 'People',
				subMenu: null,
				hide: !permissions?.['product-services.index'],
			},
			invoice: {
				id: 'invoicePage',
				text: 'Invoice',
				path: 'invoices?page=1&limit=20',
				icon: 'Calculate',
				subMenu: null,
				hide: !permissions?.['accounting.invoice_menu'],
			},

			bill: {
				id: 'billPage',
				text: 'Bill',
				path: 'bills?page=1&limit=20',
				icon: 'Calculate',
				subMenu: null,
				hide: !permissions?.['accounting.bill_menu'],
			},

			// latestSoldVehicle: {
			// 	id: 'soldLatestVehiclePage',
			// 	text: 'Auction Sold',
			// 	path: 'sold-latest-vehicle',
			// 	icon: 'Money',
			// 	subMenu: null,
			// 	hide: !permissions?.['accounting.sold_vehicle'],
			// },

			// directSoldVehicle: {
			// 	id: 'soldDirectVehiclePage',
			// 	text: 'Direct Sold',
			// 	path: 'sold-direct-vehicle?page=1&limit=20',
			// 	icon: 'Money',
			// 	subMenu: null,
			// 	hide: !permissions?.['accounting.sold_vehicle'],
			// },

			relistAndReturn: {
				id: 'relistAndReturnPage',
				text: 'Listing fee & Return',
				path: 'relist-return-car',
				icon: 'SettingsBackupRestore',
				subMenu: null,
				hide: !permissions?.['accounting.return_relist_vehicle'],
			},
			reports: {
				id: 'reportAccounting',
				text: 'Reports',
				path: 'reports',
				icon: 'InsertDriveFile',
				subMenu: null,
				hide: !permissions?.['accounting.reports'],
			},
			consignerBill: {
				id: 'consignerBill',
				text: 'Con. Bill Reports',
				path: 'consingner-bill',
				icon: 'InsertDriveFile',
				subMenu: null,
				hide: !permissions?.['accounting.consigner_bill_reports'],
			},

			pettyAccountant: {
				id: 'pettyAccountant',
				text: 'Petty Cash',
				path: 'petty-accountant',
				icon: 'MonetizationOn',
				subMenu: null,
				hide: false, // !permissions?.['petty.accountant'],
			},
		},
	},
});

const customers = (permissions) => ({
	pages: {
		id: 'customer-pages',
		text: 'Customers',
		icon: 'Extension',
	},
	singlePages: {
		id: 'customerPages',
		text: 'Customer',
		path: 'customers',
		icon: 'ManageAccounts',
		subMenu: {
			seller: {
				id: 'sellerPage',
				text: 'Sellers',
				path: 'customers/sellers?page=1&limit=20',
				icon: 'People',
				subMenu: null,
				hide: !permissions?.['seller.index'],
			},
			member: {
				id: 'memberPage',
				text: 'Customers',
				path: 'customers/members?page=1&limit=20',
				icon: 'People',
				subMenu: null,
				hide: !permissions?.['member.index'],
			},
			// newMember: {
			// 	id: 'newMemberPage',
			// 	text: 'New Members',
			// 	path: 'customer-settings/new-members?page=1&limit=20',
			// 	icon: 'People',
			// 	subMenu: null,
			// 	hide: !permissions?.['member.index'],
			// },
		},
	},
});

const sellers = (permissions) => ({
	singlePages: {
		id: 'sellerPage',
		text: 'Sellers',
		path: 'customer-settings/sellers?page=1&limit=20',
		icon: 'People',
		subMenu: null,
		hide: !permissions?.['seller.index'],
	},
});

const buyers = (permissions) => ({
	singlePages: {
		id: 'memberPage',
		text: 'Customers',
		path: 'customers/members?page=1&limit=20',
		icon: 'People',
		subMenu: null,
		hide: !permissions?.['member.index'],
	},
});

const documentAlert = (permissions) => ({
	singlePages: {
		id: 'member_doc_validate_page',
		text: 'Document Alert',
		path: 'customer-alerts/members?page=1&limit=20',
		icon: 'AddAlert',
		subMenu: null,
		hide: !permissions?.['membermenu.document_alert'],
	},
});

// const faqs = (permissions) => ({
// 	singlePages: {
// 		id: 'faqsPage',
// 		text: 'FAQ',
// 		path: 'faqs?page=1&limit=20',
// 		icon: 'Quickreply',
// 		subMenu: null,
// 		hide: !permissions?.['faq.index'],
// 	},
// });

const customer_queries = (permissions) => ({
	singlePages: {
		id: 'customer_queries_page',
		text: 'Customer Queries',
		path: 'customer-queries?page=1&limit=20',
		icon: 'Quickreply',
		subMenu: null,
		hide: !permissions?.['faq.customer_queries'],
	},
});

// const accounting = (permissions) => ({
// 	singlePages: {
// 		id: 'accountingPage',
// 		text: 'Accounting',
// 		path: '/accounting',
// 		icon: 'Calculate',
// 		subMenu: null,
// 		hide: !permissions?.['accounting.index'],
// 	},
// });

const accountingUrl = (url) => ({
	singlePages: {
		id: 'accountingPage',
		text: 'Accounting',
		path: url,
		icon: 'Calculate',
		subMenu: null,
		hide: url ? false : true,
	},
});

const auctions = (permissions) => ({
	singlePages: {
		id: 'auctions',
		text: 'Auctions',
		path: 'auctions?page=1&limit=20',
		icon: 'Bullhorn',
		subMenu: null,
		hide: !permissions?.['auction.index'],
	},
});

const bidAuction = (permissions) => ({
	singlePages: {
		id: 'bidAuction',
		text: 'Auction Bids',
		path: 'auction-bids?page=1&limit=20',
		icon: 'Construction',
		subMenu: null,
		hide: !permissions?.['bid_history.index'],
	},
});

const proposedLot = (permissions) => ({
	singlePages: {
		id: 'proposedLot',
		text: 'Proposed Lot',
		path: 'proposed-lot?page=1&limit=20',
		icon: 'FindReplace',
		subMenu: null,
		hide: !permissions?.['proposed_lot.index'],
	},
});

const activityLog = (permissions) => ({
	singlePages: {
		id: 'activityLog',
		text: 'Activity Log',
		path: 'activity-logs?page=1&limit=20',
		icon: 'RuleFolder',
		subMenu: null,
		hide: !permissions?.['activity_logs.index'],
	},
});
const manualActivityLog = (permissions) => ({
	singlePages: {
		id: 'activityLog',
		text: 'Manual Activity',
		path: 'activity-manual-logs?page=1&limit=20',
		icon: 'RuleFolder',
		subMenu: null,
		hide: !permissions?.['activity_logs.index'],
	},
});

const paddle = (permissions) => ({
	pages: {
		id: 'paddle',
		text: 'Paddle',
		icon: 'Accessible',
	},
	singlePages: {
		id: 'paddle-pages',
		text: 'Paddle',
		path: 'paddles?page=1&limit=20',
		icon: 'RuleFolder',
		subMenu: null,
		hide: !permissions?.['paddle.index'],
	},
});

const gatePass = (permissions) => ({
	pages: {
		id: 'gate-pass',
		text: 'Gate Pass',
		icon: 'Accessible',
	},
	singlePages: {
		id: 'gatePassMenu',
		text: 'Gate Pass',
		path: 'gate-pass',
		icon: 'Accessible',
		subMenu: {
			seller_entry: {
				id: 'sellerEntryPage',
				text: 'Seller Entry',
				path: 'gate-pass-seller-entry?type=seller_entry&page=1&limit=20',
				icon: 'Accessibility',
				subMenu: null,
				hide: !permissions?.['gatekeeper.seller_entry'],
			},
			seller_return: {
				id: 'sellerReturnPage',
				text: 'Seller Return',
				path: 'gate-pass-seller-return?type=seller_return&page=1&limit=20',
				icon: 'Accessibility',
				subMenu: null,
				hide: !permissions?.['gatekeeper.seller_return'],
			},
			buyer_exit: {
				id: 'buyerExitPage',
				text: 'Buyer Exit',
				path: 'gate-pass-buyer-exit?type=buyer_exit&page=1&limit=20',
				icon: 'Accessibility',
				subMenu: null,
				hide: !permissions?.['gatekeeper.buyer_exit'],
			},
		},
	},
});

const jobs = (permissions) => ({
	singlePages: {
		id: 'jobs',
		text: 'Jobs',
		path: 'jobs?page=1&limit=20',
		icon: 'AddTask',
		subMenu: null,
		hide: !permissions?.['jobs.index'],
	},
});

const faqs = (permissions) => ({
	singlePages: {
		id: 'faq-page',
		text: 'FAQ',
		path: 'faqs?page=1&limit=20',
		icon: 'Quickreply',
		subMenu: null,
		hide: !permissions?.['faq.index'],
	},
});

const downloadFile = (permissions) => ({
	singlePages: {
		id: 'downloadFile',
		text: 'Download Files',
		path: 'settings/download-files?page=1&limit=20',
		icon: 'DriveFileMove',
		hide: !permissions?.['downloads.index'],
	},
});

const catalogs = (permissions) => ({
	singlePages: {
		id: 'catalogs',
		text: 'Catalogs',
		path: 'settings/catalogs?page=1&limit=20',
		icon: 'DriveFileMove',
		hide: !permissions?.['catalogues.index'],
	},
});

const banners = (permissions) => ({
	singlePages: {
		id: 'banners',
		text: 'Banners',
		path: 'settings/banners?page=1&limit=20',
		icon: 'Image',
		hide: !permissions?.['banners.index'],
	},
});

const profiles = () => ({
	singlePages: {
		id: 'profilePage',
		text: 'Profiles',
		path: 'profiles',
		icon: 'Quickreply',
		subMenu: null,
		// hide: !permissions?.['faq.index'],
	},
});

export {
	accountingPage,
	accountingUrl,
	accountPage,
	activityLog,
	allVehicle,
	auctions,
	banners,
	bannerSlider,
	bidAuction,
	buyers,
	catalogs,
	customer_queries,
	customers,
	documentAlert,
	downloadFile,
	faqs,
	gatePass,
	jobs,
	manualActivityLog,
	misc,
	paddle,
	profiles,
	proposedLot,
	sellers,
	settings,
	vehiclePages,
	vehicles
};

